import { render, staticRenderFns } from "./communityConsultation.vue?vue&type=template&id=5d41fa2a&"
import script from "./communityConsultation.vue?vue&type=script&lang=js&"
export * from "./communityConsultation.vue?vue&type=script&lang=js&"
import style0 from "./communityConsultation.vue?vue&type=style&index=0&id=5d41fa2a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports